import { render, staticRenderFns } from "./newTaskListIcon.vue?vue&type=template&id=ad608606&scoped=true"
import script from "./newTaskListIcon.vue?vue&type=script&lang=js"
export * from "./newTaskListIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad608606",
  null
  
)

export default component.exports